const CustomCheckbox = ({
  options = [],
  selectedOptions = [],
  onChange,
}) => {
  const selectedValues = Array.isArray(selectedOptions) ? selectedOptions : [];

  const handleCheckboxChange = (value) => {
    let updatedValues;
    
    if (selectedValues.includes(value)) {
      updatedValues = selectedValues.filter(item => item != value);
    } else {
      updatedValues = [...selectedValues, value];
    }
    
    onChange && onChange(updatedValues);
  };

  return (
    <div className="d-flex flex-column ">
      {options.map((option) => (
        <label
          key={option.value}
          className="d-flex align-items-center gap-sm"
        >
          <input
            type="checkbox"
            value={option.value}
            checked={selectedValues.includes(option.value)}
            onChange={() => handleCheckboxChange(option.value)}
          />
          <span>{option.label}</span>
        </label>
      ))}
    </div>
  );
};

export default CustomCheckbox;
